import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { STUDIO } from "../lib/content";

export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="bg-[#1C1A18] text-[#F4F1EB] px-6 md:px-12 pt-24 pb-10"
  >
    <div className="max-w-[1600px] mx-auto">
      <div className="grid md:grid-cols-2 gap-16 pb-20 border-b border-[#F4F1EB]/10">
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#C49A76] mb-6">
            Un projet en tête ?
          </p>
          <Link
            to="/contact"
            data-testid="footer-contact-cta"
            className="font-serif-el text-5xl md:text-7xl leading-[0.95] hover:text-[#C49A76] transition-colors duration-500 inline-flex items-start gap-3"
          >
            Discutons-en
            <ArrowUpRight className="mt-2 md:mt-4" size={40} />
          </Link>
        </div>
        <div className="flex flex-col md:items-end justify-end gap-2 text-[#F4F1EB]/70 font-light">
          <a href={STUDIO.emailHref} className="hover:text-[#C49A76] transition-colors duration-300">
            {STUDIO.email}
          </a>
          <a href={STUDIO.phoneHref} className="hover:text-[#C49A76] transition-colors duration-300">
            {STUDIO.phone}
          </a>
          <p>{STUDIO.address}</p>
        </div>
      </div>
      <div className="pt-8 flex flex-col md:flex-row justify-end gap-4 text-xs uppercase tracking-[0.15em] text-[#F4F1EB]/50">
        <span>© {new Date().getFullYear()} — {STUDIO.name}, {STUDIO.city}</span>
      </div>
    </div>
  </footer>
);
